import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  onRenderColumnStack: {
    height: 25,
  },
  iconStyle: {
    marginRight: 0,
  },
  activationStatus: {
  borderRadius: 5,
  height: 30,
  minWidth: 90,
  maxWidth: 90,
  padding: 10,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  color: 'white',
},
}));
